
import Rewards from '~/pages/_lang/rewards'
export default Rewards
